import { useStore } from '@nanostores/react'
import { useState } from 'react'
import { $debugAfterPaymentError } from '~/store/debug'

export function DevTools() {
  const [isOpen, setIsOpen] = useState(false)
  const debugAfterPaymentError = useStore($debugAfterPaymentError)

  return (
    <div className="fixed left-2 top-[calc(8px+var(--safe-area-top))] z-[9999]">
      {isOpen ? (
        <div className="flex flex-col gap-1 rounded-lg bg-black/80 p-2 text-xs text-white shadow-lg">
          <div className="mb-1 flex items-center justify-between gap-2">
            <span className="font-semibold">Debug</span>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white/60 hover:text-white"
            >
              ✕
            </button>
          </div>
          <label className="flex cursor-pointer items-center gap-2">
            <input
              type="checkbox"
              checked={debugAfterPaymentError}
              onChange={(e) =>
                $debugAfterPaymentError.set(e.currentTarget.checked)
              }
              className="h-4 w-4 cursor-pointer"
            />
            <span className="select-none">Simulate AfterPaymentError</span>
          </label>
        </div>
      ) : (
        <button
          onClick={() => setIsOpen(true)}
          className="rounded-full bg-black/80 px-3 py-1.5 text-xs font-medium text-white shadow-lg"
        >
          Debug
        </button>
      )}
    </div>
  )
}
